import "core-js/modules/es.object.has-own.js";
var render = function render() {
  var _vm$prescription, _vm$prescription$canc;
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "card-container tw-cursor-pointer tw-rounded-md",
    class: [_vm.effectiveStatus.replace(/\s+/g, '-').toLowerCase(), _vm.selected ? 'selected' : 'tw-border !tw-border-transparent'],
    attrs: {
      "border-variant": "light"
    },
    on: {
      "click": function ($event) {
        return _vm.openAirtableRecord(_vm.prescription);
      }
    }
  }, [_c('div', {
    staticClass: "tw-mb-3 tw-flex tw-items-start"
  }, [_c('div', {
    staticClass: "tw-w-[45%]"
  }, [_c('h2', {
    staticClass: "tw-m-0 tw-font-atten tw-text-xl tw-font-bold tw-text-[#19191C]"
  }, [_vm._v(" " + _vm._s(_vm.prescription.medicinename) + " ")]), _c('p', {
    staticClass: "tw-m-0 tw-text-sm"
  }, [_vm._v(" " + _vm._s(_vm.displayDosage) + " ")]), _c('h4', {
    staticClass: "card-status mb-0 tw-flex tw-flex-wrap tw-items-center tw-gap-1 tw-text-sm tw-leading-snug"
  }, [_c('span', [_vm._v(_vm._s(_vm.getRefillString(_vm.prescription)))]), _vm.prescription.upsellrenewalrequested ? _c('b-badge', {
    staticClass: "status-needs-refill tw-inline-flex tw-items-center tw-gap-1",
    attrs: {
      "pill": ""
    }
  }, [_c('IconRefresh', {
    staticClass: "tw-size-3"
  }), _vm._v(" Needs Refill ")], 1) : _vm._e()], 1), _c('h4', {
    staticClass: "mb-0 tw-text-sm tw-leading-snug tw-text-muted"
  }, [_vm._v(" " + _vm._s(_vm.prescription.unit) + " ")])]), _c('div', {
    staticClass: "tw-w-[55%] tw-flex-1 tw-pl-2 tw-text-right"
  }, [_c('div', {
    staticClass: "text-primary card-status tw-mb-0 tw-flex tw-items-center tw-justify-end tw-text-sm tw-capitalize"
  }, [_vm.prescription && _vm.effectiveStatus == 'WAITING' ? _c('span', {
    staticClass: "mr-3 text-small"
  }, [_vm._v(" " + _vm._s(_vm.timer) + " seconds ")]) : _vm._e(), _c('span', {
    staticClass: "tw-capitalize"
  }, [_vm._v(" " + _vm._s(_vm.effectiveStatus.toLowerCase()) + " "), _vm.effectiveStatus === 'CANCELLED' ? _c('span', {
    class: {
      'tw-block': (_vm$prescription = _vm.prescription) === null || _vm$prescription === void 0 ? void 0 : (_vm$prescription$canc = _vm$prescription.cancelledbyrole) === null || _vm$prescription$canc === void 0 ? void 0 : _vm$prescription$canc.includes('PEANUT ALLERGY')
    }
  }, [Object.hasOwn(_vm.prescription, 'can_restart') ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(" (Stripe) ")]) : _vm.prescription.cancelledbyrole ? _c('span', {
    staticClass: "text-capitalize ml-1"
  }, [_vm._v(" (" + _vm._s(_vm.prescription.cancelledbyrole.toLowerCase()) + ") ")]) : _vm._e()]) : _vm._e()])]), _vm.effectiveStatus == 'PAUSED' ? _c('p', {
    staticClass: "scheduled-text text-muted tw-mb-0 tw-ml-1 tw-whitespace-nowrap tw-text-sm"
  }, [_vm._v(" (Paused until: "), _vm.prescription.resumecollection ? _c('span', [_vm._v(" " + _vm._s(_vm.parseUnixDate(_vm.prescription.resumecollection, 'yyyy-MM-dd')) + " ")]) : _c('span', [_vm._v(" Indefinite ")]), _vm._v(" ) ")]) : _vm._e(), _vm.effectiveStatus == 'SCHEDULED' ? _c('p', {
    staticClass: "scheduled-text text-muted tw-mb-0 tw-whitespace-nowrap tw-text-sm"
  }, [_vm._v(" (Scheduled for: " + _vm._s(_vm.parseUnixDate(_vm.prescription.timestampsubscriptionstartdate, 'MM/dd/yy')) + ") ")]) : _vm._e(), _vm.prescription.airtablestatus && !_vm.shouldTreatAsCompleted ? _c('span', {
    staticClass: "badge tw-rounded-full tw-px-2 tw-py-1",
    class: `status-${_vm.prescription.airtablestatus.replace(/\s+/g, '-').toLowerCase()}`
  }, [_vm._v(" " + _vm._s(_vm.prescription.airtablestatus) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "tw-flex tw-justify-between"
  }, [_c('div', {
    staticClass: "tw-flex tw-gap-8"
  }, [_c('div', [_c('div', {
    staticClass: "tw-text-xs tw-text-muted"
  }, [_vm._v(" Prescribed ")]), _c('div', {
    staticClass: "tw-text-xs"
  }, [_vm._v(" " + _vm._s(_vm.prescription.timestampprescibed ? _vm.parseUnixDate(_vm.prescription.timestampprescibed, 'MM/dd/yy') : '-') + " ")])]), _c('div', [_c('div', {
    staticClass: "tw-text-xs tw-text-muted"
  }, [_vm._v(" Last Refill Ends ")]), _c('div', {
    staticClass: "tw-text-xs"
  }, [_vm._v(" " + _vm._s(_vm.hasRefills && _vm.prescription.actualenddate ? _vm.parseUnixDate(_vm.prescription.actualenddate, 'MM/dd/yy') : '-') + " ")])]), _vm.prescription.refills - _vm.prescription.paidrefills > 0 ? _c('div', [_c('div', {
    staticClass: "tw-text-xs tw-text-muted"
  }, [_vm._v(" Next Refill ")]), _c('div', {
    staticClass: "tw-flex tw-items-center"
  }, [_c('p', {
    staticClass: "mb-0 mr-2 tw-text-xs"
  }, [_vm._v(" " + _vm._s(_vm.prescription.nextshipmentdate && _vm.prescription.transactiontype !== 'one_time' ? _vm.parseUnixDate(_vm.prescription.nextshipmentdate, 'MMMM d, yyyy') : '-') + " ")])])]) : _vm._e()]), _vm.enableControls ? _c('div', {
    staticClass: "tw-flex tw-items-center tw-justify-end"
  }, [_c('VTooltip', {
    scopedSlots: _vm._u([{
      key: "popper",
      fn: function () {
        return [_vm._v(" Prescription history ")];
      },
      proxy: true
    }], null, false, 2898596087)
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("@/assets/images/prescription_info.svg"),
      "alt": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-prescription-history', _vm.prescription);
      }
    }
  })])]), _vm.isStripeCancellable || !['CANCELLED', 'COMPLETED', 'PROCESSING', 'MIGRATED'].includes(_vm.effectiveStatus) || Object.hasOwn(_vm.prescription, 'can_restart') && !_vm.isMoreThan90Days(_vm.prescription.timestampcancelled) ? _c('div', [_c('b-dropdown', {
    staticClass: "more-dropdown",
    attrs: {
      "size": "lg",
      "variant": "link",
      "toggle-class": "text-decoration-none p-0 ml-2",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('img', {
          attrs: {
            "src": require("@/assets/images/more.svg"),
            "alt": ""
          }
        })];
      },
      proxy: true
    }], null, false, 1331942805)
  }, [Object.hasOwn(_vm.prescription, 'can_restart') && !_vm.isMoreThan90Days(_vm.prescription.timestampcancelled) && (_vm.isStripeCancellable || !(_vm.disablePlay() || _vm.effectiveStatus === 'WAITING' && _vm.prescription.delayuntil >= _vm.getUnixTime(new Date()))) ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-toggle-prescription', false, _vm.prescription);
      }
    }
  }, [_vm._v(" Restart Prescription ")]) : !(_vm.disablePlay() || _vm.effectiveStatus === 'WAITING' && _vm.prescription.delayuntil >= _vm.getUnixTime(new Date())) ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-toggle-prescription', true, _vm.prescription);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.effectiveStatus === 'PAUSED' ? 'Resume prescription' : _vm.effectiveStatus === 'FAILED' ? 'Retry prescription' : 'Play prescription') + " ")]) : _vm._e(), !_vm.disablePause() && _vm.prescription.transactiontype !== 'one_time' ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.openPausePrescription(_vm.prescription);
      }
    }
  }, [_vm._v(" Pause Prescription ")]) : _vm._e(), !_vm.disableStop() ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.openSingleCancel(_vm.prescription);
      }
    }
  }, [_vm._v(" Cancel Prescription ")]) : _vm._e(), _vm.effectiveStatus === 'PRESCRIBED' && _vm.prescription.refills - _vm.prescription.paidrefills !== 0 ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-refill', {
          ..._vm.prescription
        });
      }
    }
  }, [_vm._v(" Activate Next Refill ")]) : _vm._e(), _vm.effectiveStatus === 'PRESCRIBED' ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-move-refill', {
          ..._vm.prescription,
          fullname: `${_vm.patientData.firstname} ${_vm.patientData.lastname}`,
          ongoingItems: _vm.ongoingItems,
          hysterectomy: _vm.patientData.hysterectomy
        });
      }
    }
  }, [_vm._v(" Edit Refill Date ")]) : _vm._e(), _vm.effectiveStatus === 'SCHEDULED' ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-move-prescription-start-date', {
          ..._vm.prescription,
          fullname: `${_vm.patientData.firstname} ${_vm.patientData.lastname}`,
          ongoingItems: _vm.ongoingItems,
          hysterectomy: _vm.patientData.hysterectomy
        });
      }
    }
  }, [_vm._v(" Edit Start Date ")]) : _vm._e(), _vm.effectiveStatus === 'PRESCRIBED' ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-escript', {
          ..._vm.prescription
        });
      }
    }
  }, [_vm._v(" Re-send Escript ")]) : _vm._e(), _vm.isAirtableProcessing ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-rush', {
          ..._vm.prescription,
          fullname: `${_vm.patientData.firstname} ${_vm.patientData.lastname}`
        });
      }
    }
  }, [_vm._v(" Rush Prescription ")]) : _vm._e(), _vm.effectiveStatus === 'PRESCRIBED' ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-send-replacement', {
          ..._vm.prescription,
          fullname: `${_vm.patientData.firstname} ${_vm.patientData.lastname}`
        });
      }
    }
  }, [_vm._v(" Send Replacement ")]) : _vm._e(), _vm.isAirtableProcessing ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-cancel-order', _vm.prescription);
      }
    }
  }, [_vm._v(" Cancel Processing Order ")]) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };